import { Injectable } from '@angular/core';
import { Estado } from "@tivic-team/manager-ts/dist/grl";
import { ApiController } from 'app/controllers/api-controller.interface';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environmentv3 } from 'src/environments/environmentv3';

@Injectable()
export class EstadoController implements ApiController<Estado>{
    
    constructor() { }

    find(filters?: IFilter): Promise<Estado[]> {
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'grl/estados',
                    environment: environmentv3,
                    filter: filters
                }),
            }),
            new HttpResponse(
                new Array<Estado>()
            )
        );
        return quark.call();
    }

    create(entity: Estado): Promise<Estado> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'grl/estados',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Estado()
            )
        );
        return request.call();
    }
    
    update(entity: Estado): Promise<Estado> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'grl/estados/:cdEstado',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdEstado: entity.cdEstado
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Estado()
            )
        );
        return request.call();
    }
	
    get(cdEstado:number):Promise<Estado>{	
        let request = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/estados/:cdEstado',
					environment: environmentv3,
					pathParams: new JSONData({cdEstado: cdEstado})
				}),
			}),
			new HttpResponse(
			  new Estado()
			)
        );
        return request.call();
	}

    findEstados(filters?: IFilter): Promise<Estado[]> {
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'grl/estados/estados',
                    environment: environmentv3,
                    filter: filters
                }),
            }),
            new HttpResponse(
                new Array<Estado>()
            )
        );
        return quark.call();
    }
}
